export const MESES = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
export const MESES_CORTO = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

const entero = new Intl.NumberFormat("es-BO", { maximumFractionDigits: 0 });
export const bs = (v) => `Bs ${entero.format(Math.round(Number(v) || 0))}`;
export const numero = (v) => entero.format(Math.round(Number(v) || 0));

// Eje y etiquetas cortas: 1.2M, 850K
export const compacto = (v) => {
  const n = Math.abs(Number(v) || 0);
  const signo = Number(v) < 0 ? "-" : "";
  if (n >= 1_000_000) return `${signo}${(n / 1_000_000).toLocaleString("es-BO", { maximumFractionDigits: 1 })}M`;
  if (n >= 1_000) return `${signo}${Math.round(n / 1_000)}K`;
  return `${signo}${Math.round(n)}`;
};

// Variación porcentual contra el periodo anterior; null si no hay base para comparar.
export const variacion = (actual, anterior) => {
  const a = Number(actual) || 0;
  const b = Number(anterior) || 0;
  if (!b) return null;
  return ((a - b) / b) * 100;
};
